<template>
    <!-- Loading -->
    <div class="vld-parent">
      <loading
        v-model:active="isLoading"
        :is-full-page="true"
        :height="128"
        :width="128" />
    </div>

    <!-- Image -->
    <div class="flex justify-center bg-gray-100 dark:bg-gray-600 w-full transition-position duration-700" style="height: 86vh">
      <div class="flex items-center w-6/12 transition-position duration-700">
        <span class="text-bold">
          <img src="../assets/general/logo-amatra.png" alt="logo">
        </span>
      </div>
    </div>
  </template>

  <script>
    import { ref, onMounted, onBeforeMount, computed, watchEffect } from 'vue'
    import { useStore } from 'vuex'
    import { mdiCheckBold, mdiPlusCircleOutline, mdiClose } from '@mdi/js'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'

    export default {
      name: 'HomeModule',
      components: {
        Loading
      },
      data () {
        return {
        }
      },
      emits: ['close-modal', 'submit'],
      setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Dashboard'])
        const store = useStore()
        const darkMode = computed(() => store.state.darkMode)
        const isLoading = ref(false)
        const userLogin = localStorage.getItem('name')
        const userRole = localStorage.getItem('roles')
        const usernameLogin = localStorage.getItem('username')

        onMounted(() => {})
        onBeforeMount(() => {})
        watchEffect(() => {})

        return {
          mdiCheckBold,
          mdiPlusCircleOutline,
          mdiClose,
          titleStack,
          darkMode,
          isLoading,
          userLogin,
          usernameLogin,
          userRole
        }
      },
      methods: {
      }
    }
  </script>
